import React, { Component } from 'react';
import { spring, StaggeredMotion } from 'react-motion';

import { DataHandler, ToolboxCard, ContentHeader } from 'C4';
import { storageKeys } from 'settings';
import i18n from 'i18n-react';

import APIHandler from 'config/APIHandler';

export default class Toolbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toolbox: [],
    };
  }

  componentWillMount() {
    DataHandler.matchAppId().then((appId) => {
      APIHandler.getToolbox(appId).then((res) => {
        const startingValues = [];
        Object.keys(res).map(() => {
          const newObj = {};
          newObj.data = 0;
          newObj.pos = 20;
          return startingValues.push(newObj);
        });
        const toolboxItems = (
          <StaggeredMotion
            defaultStyles={startingValues}
            styles={(prevInterpolatedStyles) =>
              prevInterpolatedStyles.map((_, i) =>
                i === 0
                  ? {
                      data: spring(1, { stiffness: 320, damping: 28 }),
                      pos: spring(0, { stiffness: 320, damping: 28 }),
                    }
                  : {
                      data: spring(prevInterpolatedStyles[i - 1].data, {
                        stiffness: 320,
                        damping: 28,
                      }),
                      pos: spring(prevInterpolatedStyles[i - 1].pos, {
                        stiffness: 320,
                        damping: 28,
                      }),
                    }
              )
            }
          >
            {(styles) => (
              <React.Fragment>
                {res.map((tool, id) => {
                  const { type, title, subtitle, url, itemID, image } = tool;
                  if (tool.type) {
                    const key = id;
                    let header = '';
                    if (id === 5) {
                      header = (
                        <ContentHeader
                          header={i18n.translate('nav.sales')}
                          subtitle={i18n.translate('pageDescriptions.sales')}
                          line
                        />
                      );
                    }
                    if (id === 13) {
                      header = (
                        <ContentHeader
                          header={i18n.translate('nav.marketing')}
                          subtitle={i18n.translate(
                            'pageDescriptions.marketing'
                          )}
                          line
                        />
                      );
                    }
                    if (id === 15) {
                      header = (
                        <ContentHeader
                          header={i18n.translate('nav.events')}
                          subtitle={i18n.translate('pageDescriptions.events')}
                          line
                        />
                      );
                    }
                    if (id === 17) {
                      header = (
                        <ContentHeader
                          header={i18n.translate('nav.production')}
                          subtitle={i18n.translate(
                            'pageDescriptions.production'
                          )}
                          line
                        />
                      );
                    }
                    if (id === 25) {
                      header = (
                        <ContentHeader
                          header={i18n.translate('nav.service')}
                          subtitle={i18n.translate('pageDescriptions.service')}
                          line
                        />
                      );
                    }
                    if (id === 28) {
                      header = (
                        <ContentHeader
                          header={i18n.translate('nav.code')}
                          subtitle={i18n.translate('pageDescriptions.code')}
                          line
                        />
                      );
                    }
                    if (id === 33) {
                      header = (
                        <ContentHeader
                          header={i18n.translate('nav.dashboard')}
                          subtitle=""
                          line
                        />
                      );
                    }

                    return (
                      <React.Fragment>
                        {header}
                        <div
                          key={key}
                          className="ToolboxCard__Animated"
                          style={{
                            opacity: `${styles[key].data}`,
                            transform: `translateY(${styles[key].pos}%)`,
                          }}
                        >
                          <ToolboxCard
                            appId={appId}
                            image={image}
                            key={key}
                            index={key}
                            subtitle={subtitle}
                            title={title}
                            type={type}
                            url={url}
                            itemID={itemID}
                          />
                        </div>
                      </React.Fragment>
                    );
                  }
                  return null;
                })}
              </React.Fragment>
            )}
          </StaggeredMotion>
        );
        this.setState({ toolbox: toolboxItems });
      });
    });
  }

  render() {
    return <div className="toolbox__Grid">{this.state.toolbox}</div>;
  }
}
